import ContactInfo from "components/shared/contactInfo";
import { Field } from "components/shared/form";
import { ymEvent } from "helpers/system";
import React, { useState } from "react";
import { getByPhoneNumber } from "sources/books/mechanics";
import { applyCarMechanic, resetCache } from "sources/tripPlanning";

const config = {
    name: {
        label: "ФИО механика",
        inputProps: { name: "name" },
        bWrapper: "row form-group",
    },
    number: {
        label: "Телефон механика",
        bWrapper: "row",
        inputProps: { name: "phoneNumber" },
    },
};

export default function MechanicForm(props) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(props.mechanic);

    const saveData = () => {
        setLoading(true);
        applyCarMechanic({ carId: props.carId, mechanic: data }).then((res) => {
            if (res) {
                props.setMechanic(data);
                ymEvent("TripPlanningCarDetailsUsed");
                resetCache();
            }
            setLoading(false);
            props.back();
        });
    };

    const deleteData = () => {
        setLoading(true);
        applyCarMechanic({ carId: props.carId, mechanic: null }).then((res) => {
            if (res) {
                props.setMechanic(null);
                ymEvent("TripPlanningCarDetailsUsed");
                resetCache();
            }
            setLoading(false);
            props.back();
        });
    };

    const changeHandle = ({ value }) => setData({ ...data, ...value });

    const renderField = (fieldProps) => <Field {...fieldProps} />;

    return (
        <div className={loading ? "loading" : ""}>
            <ContactInfo
                {...{
                    renderField,
                    contact: data,
                    setValue: changeHandle,
                    config,
                    getContactInfo: getByPhoneNumber,
                    fieldName: "mechanic",
                }}
            />
            <div className="d-flex justify-content-between mt-2">
                {props.mechanic ? (
                    <div className="btn btn-outline-danger" onClick={deleteData}>
                        Удалить
                    </div>
                ) : (
                    <div />
                )}
                <div className="btn btn-brand" onClick={saveData}>
                    Сохранить
                </div>
            </div>
        </div>
    );
}
